import { useLanguage } from "../lib/LanguageContext"

/**
 * A compact EN / VI pill toggle.
 * `variant` = "light" (for dark backgrounds, e.g. sidebars/navbar)
 *           | "dark"  (for light backgrounds — not currently used)
 */
export default function LangToggle({ variant = "light", fullWidth = false }) {
  const { lang, setLang } = useLanguage()

  const base =
    `flex items-center overflow-hidden rounded-lg border text-[11px] font-bold tracking-wider select-none shrink-0 ${fullWidth ? "w-full" : "inline-flex rounded-full"}`
  const border = variant === "light" ? "border-white/20" : "border-ink-700/30"

  const btnBase = "flex flex-1 justify-center items-center gap-1 px-2.5 py-1.5 transition-all duration-200"
  const active = "bg-gold-500 text-ink-900"
  const inactive =
    variant === "light"
      ? "text-white/70 hover:text-white"
      : "text-ink-600 hover:text-ink-900"

  return (
    <div className={`${base} ${border}`} role="group" aria-label="Select language">
      <button
        className={`${btnBase} ${lang === "vi" ? active : inactive}`}
        onClick={() => setLang("vi")}
        aria-pressed={lang === "vi"}
        title="Tiếng Việt"
      >
        <span>VI</span>
      </button>
      <button
        className={`${btnBase} ${lang === "en" ? active : inactive}`}
        onClick={() => setLang("en")}
        aria-pressed={lang === "en"}
        title="English"
      >
        <span>EN</span>
      </button>
    </div>
  )
}
